module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Diversion Books"), _c('br'), _vm._v("\n  A Division of Diversion Publishing Corp."), _c('br'), _vm._v("\n  443 Park Avenue South, Suite 1008"), _c('br'), _vm._v("\n  New York, NY 10016"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.DiversionBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 1997 by Ellen Gilchrist"), _c('br'), _vm._v("\n  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Excerpt from “Galaxy Song.” Words and Music by Eric Idle and John De Prez. Copyright © 1983 KAY-GEE-BEE MUSIC and EMI Virgin Music Ltd. International Copyright Secured. All Rights Reserved. Reprinted by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Excerpt from “Louisiana 1927” by Randy Newman. Copyright © 1974 by Warner-Tamerlane Publishing Corp. All Rights Reserved. Reprinted by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Excerpt from “Cabaret” by Fred Ebb and John Kander. Copyright © 1966 by Alley Music Corp. and Trio Music Co., Inc. All Rights Reserved. Reprinted by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("For more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Diversion Books edition October 2017"), _c('br'), _vm._v("\n  ISBN: 978-1-63576-348-5")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dd8e832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/00b_copy.vue
// module id = 63
// module chunks = 0